import {GridModel} from '@xh/hoist/cmp/grid';
import {HoistModel, LoadSpec, XH, managed} from '@xh/hoist/core';
import {action, runInAction} from '@xh/hoist/mobx';
import {sourceCol, tokenizedHeadlineCol} from '../../../../cmp/NewsColumns';
import {NewsItem} from '../../../../data/DataTypes';
import {asServerException} from '../../../../../core/ServiceUtils';
import {PanelModel} from '@xh/hoist/desktop/cmp/panel';
import {NotificationMessage} from '../../../../data/MessageTypes';

export class NewsWidgetModel extends HoistModel {
    @managed gridModel = this.createGridModel();
    @managed panelModel = new PanelModel({
        defaultSize: 200,
        collapsible: true,
        maxSize: 200,
        side: 'bottom',
        persistWith: {prefKey: 'portfoliosTabState', path: 'newsPanelSize'}
    });

    constructor() {
        super();

        XH.messageHub.subscribe('news', this.xhId, message => this.onNewsMessage(message));
    }

    override async doLoadAsync(loadSpec: LoadSpec): Promise<void> {
        try {
            const news: NewsItem[] = await XH.newsService.fetchNewsAsync();

            this.gridModel.store.clear();
            runInAction(() => {
                this.gridModel.store.updateData(news);
            });
        } catch (e) {
            XH.handleException(asServerException(e), {title: 'Error loading news'});
        }
    }

    @action
    private onNewsMessage(message: NotificationMessage) {
        switch (message.envelope.eventType) {
            case 'UPDATE':
                this.updateNews(message.payload);
                break;
            case 'RELOAD':
                this.loadAsync();
                break;
        }
    }

    private createGridModel(): GridModel {
        return new GridModel({
            emptyText: 'No data exists',
            colChooserModel: false,
            selModel: 'disabled',
            contextMenu: null,
            autosizeOptions: {
                mode: 'onDemand'
            },
            hideHeaders: true,
            sortBy: 'id|desc',
            columns: [
                {
                    field: 'id',
                    hidden: true
                },
                {...sourceCol},
                {
                    ...tokenizedHeadlineCol
                }
            ]
        });
    }

    private updateNews(news) {
        runInAction(() => {
            if (this.gridModel.store.records.length > 0) {
                let last = this.gridModel.store.records[0];
                this.gridModel.store.removeRecords([last]);
            }
            this.gridModel.store.updateData(news);
        });
    }
}
